import * as React from 'react'
import { useTheme } from '@bestyled/primitives'
import { toCssSizePx } from '@bestyled/system'

const MediaSizeContext = React.createContext<{
  size: number
}>(null!)

const entries = (o) => Object.keys(o).map((key) => [key, o[key]])
const num = (n) => typeof n === 'number' && !isNaN(n)
const px = (n) => (num(n) ? `${n}px` : n)

export const MediaSizeProvider = React.memo((props) => {
  const theme = useTheme()

  const queries = React.useRef<any[]>(null!)
  const [currentSize, setCurrentSize] = React.useState(2)

  const update = React.useCallback(() => {
    const newSize = queries.current!.find((val) => val.mql.matches)
    if (newSize) {
      setCurrentSize(newSize.name)
    }
  }, [])

  React.useEffect(() => {
    const sourcequeries: string[] = []

    for (let i = 0; i <= theme.breakpoints.length; i++) {
      if (i === 0) {
        const n1 = toCssSizePx(theme.breakpoints[i])

        sourcequeries[i] = `(max-width: ${px(n1)})`
      } else if (i < theme.breakpoints.length) {
        const n1 = toCssSizePx(theme.breakpoints[i])

        const n0 = toCssSizePx(theme.breakpoints[i - 1])
        sourcequeries[i] = `(min-width: ${px(n0)}) and (max-width: ${px(n1)})`
      } else {
        sourcequeries[i] = `(min-width: ${theme.breakpoints[i - 1]})`
      }
    }

    queries.current = entries(sourcequeries).map(([name, query]) => {
      const mql = window.matchMedia(query)
      mql.addListener(update)
      if (mql.matches) {
        setCurrentSize(name)
      }
      return { mql, name }
    })

    return () => {
      /* on unmount */
      queries.current!.forEach(({ mql }) => {
        mql.removeListener(update)
      })
    }
  }, [theme.breakpoints])

  return (
    <MediaSizeContext.Provider value={{ size: currentSize }}>
      {props.children}
    </MediaSizeContext.Provider>
  )
})

export const useMediaSize = () => React.useContext(MediaSizeContext)
